import React, { useState } from "react"

import Button from "components/Button"

import "./CookieConsent.sass"

const CookieConsent = () => {
  const initialState =
    window.localStorage && window.localStorage.getItem("cookie-consent")

  const [consent, setConsent] = useState(initialState)

  const handleConsent = (e) => {
    e.preventDefault()
    window.localStorage && window.localStorage.setItem("cookie-consent", true)
    setConsent(true)
  }

  if (!consent) {
    return (
      <div className={"CookieConsent"}>
        <p>
          Želimo namestiti analitične piškotke ponudnika Google Analytics, ki
          nam bodo omogočili izboljšanje vsebin in uporabniške izkušnje
          spletnega mesta.{" "}
          <a
            href="https://www.amzs.si/piskotki"
            target="_blank"
            rel="noopener noreferrer"
          >
            Več informacij
          </a>
          .
        </p>
        <Button onClick={handleConsent} isInverse>
          Strinjam se
        </Button>
      </div>
    )
  } else {
    return false
  }
}

export default CookieConsent
